import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './routes/Diagnostic.visual-fix.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root introuvable dans index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);